import { toast } from "react-toastify";
import { useGeneralAppStore } from "../store/generalAppStore";
import { axios } from "../utils/axios";
import { toastOptions } from "../config/toast";

const { handlerLoading, handlerModal } = useGeneralAppStore.getState();

//TODO trae toda als actas segun su estado y los filtros
// export const bajaActaTribunal = async (payload) => {
export const bajaActaTribunal = async (params, setRefetch) => {
  handlerLoading({ loading: true, loadName: "baja_tribunal" });
  try {
    // const response = await axios().post("/baja_tribunal", payload);
    const response = await axios().patch(`/marcar_baja_tribunal/${params}`);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    toast.success("Se marco el acta tribunal correctamente", toastOptions);
    if (setRefetch) setRefetch(true);
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "baja_tribunal" });
  }
};

//TODO trae la constaqncia de anulacion de un aca anulada
// export const bajaActaTribunal = async (payload) => {
export const constanciaAnulacion = async (payload) => {
  handlerLoading({ loading: true, loadName: "constancia_anulacion" });
  try {
    // const response = await axios().post("/baja_tribunal", payload);
    const response = await axios().post(`/get_constancia_anulacion`, payload);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    // toast.success("Se marco el acta tribunal correctamente", toastOptions);
    
    // if (setRefetch) setRefetch(true);
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "constancia_anulacion" });
  }
};
